/**
 * Created by rhinov15 on 18/07/2017.
 *
 * CLosetDoor joinery entity node (porte de placard)
 */

import { JoineryNode } from "../JoineryNode";
import { PlanManager } from "../../../../../cocosPlan";
import { CupboardDoor, SceneConstants } from "@rhinov/savane-js";

declare var cc: any;

export class CupboardDoorNode extends JoineryNode {
    constructor(jOpening: CupboardDoor) {
         // Call super class constructor
        super(jOpening);
        // And prepare the node for display
        this.computeModel(jOpening);
    }

     // Prepare node for display
    computeModel (joinery: CupboardDoor) {
        // Retrieve joinery parameters if not undefined
        if (joinery !== undefined) {
            this._length = joinery.length;
            if (joinery.wall != null)
                this._thickness = joinery.wall.thickness;
            else
                this._thickness = this._length / 10;

            this.nbDoors = joinery.nbDoors;
            this.handleSide = joinery.handleSide;
        }

        // Create one sprite per door of the joinery
        for (var i = 0; i < this.nbDoors; ++i) {
            // New sprite
            var sprite = new cc.Sprite();
            var word = '';
            // Sprite texture image name
            var spriteName = this.nbDoors > 1 ? (i % 2 == 0 ? 'plan/closetDoor' + word + '.png' : 'plan/closetDoor' + word + '.png') : 'plan/closetDoor' + word + '.png';
            // Init sprite texture image
            sprite.initWithSpriteFrameName(spriteName);
            // Set anchoring
            sprite.setAnchorPoint(new cc.p((i + 1) - (this.nbDoors * 0.5), 1));
            if (this.transparentDraw) {
                sprite.setOpacity(64);
            }
            // Set scale X and Y
            sprite.setScaleX(this._length / (sprite.width * 10 * this.nbDoors));
            sprite.setScaleY(this._thickness / 1000);
            // Set position and name
            sprite.setPositionY(-0.5);
            sprite.setName('door-' + i);
            // And add the sprite to the rendering
            this.addChild(sprite);
        }
    }

    // Draw manual rectangles for the node
    drawOverlap (joinery: CupboardDoor, isValid: boolean) {
        var alpha = 255;
        if (this.transparentDraw) {
            alpha = 64;
        }
        // Clear the node display
        this.clear();
        // If the node thickness > 0 (it would be invisible)
        if (this._thickness > 0) {
            // x, y, w, h of the element being displayed
            var h = (this._thickness * 0.1);
            var w = this._length * 0.1 - 1;
            var y = -h * 0.5;
            var x = -w * 0.5;
            // Color to use for the display
            var color: {border: any, plain: any} = {border: undefined, plain: undefined};
            // Border size
            var borderSize = 1;

            // Select color depending on valid/invalid, selected/unselected
            if (isValid !== undefined) {
                color = this.getOverLapColor(isValid);
            }
            else {
                color = this.getOverLapColor(true);
            }

            if (borderSize * PlanManager.getInstance().getZoomScale() < 1) {
                borderSize /= PlanManager.getInstance().getZoomScale();
            }
            this.drawRect(new cc.p(x, y), new cc.p(x + w, y + h), color.plain, borderSize, color.border);
            this.drawRect(new cc.p(x - 0.5, y - 0.5), new cc.p(x + w * 0.015, y + h + 0.5), new cc.Color(66, 80, 94, alpha), 1, new cc.Color(66, 80, 94, 0));
            this.drawRect(new cc.p(x + w - w * 0.015, y - 0.5), new cc.p(x + w + 0.5, y + h + 0.5), new cc.Color(66, 80, 94, alpha), 1, new cc.Color(66, 80, 94, 0));

            if (this.nbDoors === 1) {
                if (this.handleSide === SceneConstants.HandleSide.handle_right) {
                    this.drawRect(new cc.p(x + w - (w * 0.1) - borderSize * 0.5, y - (h / 12) + borderSize * 0.5),
                        new cc.p(x + w - (w * 0.04) + borderSize * 0.5, y + borderSize * 0.5),
                        new cc.Color(66, 80, 94, alpha), borderSize, new cc.Color(66, 80, 94, alpha));
                }
                else {
                  this.drawRect(new cc.p(x + (w * 0.1) - borderSize * 0.5, y - (h / 12) + borderSize * 0.5),
                      new cc.p(x + (w * 0.04) + borderSize * 0.5, y + borderSize * 0.5),
                      new cc.Color(66, 80, 94, alpha), borderSize, new cc.Color(66, 80, 94, alpha));
                }
            }
        }
    }

    // Update node model, prepare for next frame display
    updateModel (joinery: CupboardDoor, isValid: boolean) {
        // Empty current node display
        this.removeAllChildren();
        // Add prepare the content to display
        this.computeModel(joinery);
        // Call Joinery node update model method
        super.updateModel(joinery, isValid);
        // Draw node additionnal rects
        this.drawOverlap(joinery, isValid);
    }
}
